import { Chip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { style } from './style';

type RunStatusProps = {
  status: string,
}

export const RunStatus = ({
  status,
}:RunStatusProps):JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Chip
      variant="outlined"
      label={ translate(status) }
      sx={ {
        border: 0,
        ...style.colors[status],
      } }
    />
  );
};
